"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrequalSliderSelectionSource = exports.DebtSwapTradelineSelectionBlockReason = void 0;
var DebtSwapTradelineSelectionBlockReason;
(function (DebtSwapTradelineSelectionBlockReason) {
    DebtSwapTradelineSelectionBlockReason["requiredForDtiRecovery"] = "requiredForDtiRecovery";
})(DebtSwapTradelineSelectionBlockReason || (exports.DebtSwapTradelineSelectionBlockReason = DebtSwapTradelineSelectionBlockReason = {}));
var PrequalSliderSelectionSource;
(function (PrequalSliderSelectionSource) {
    PrequalSliderSelectionSource["MortgageLoanOfficer"] = "MortgageLoanOfficer";
    PrequalSliderSelectionSource["Applicant"] = "Applicant";
})(PrequalSliderSelectionSource || (exports.PrequalSliderSelectionSource = PrequalSliderSelectionSource = {}));
